import React, { useEffect, useState } from 'react';
import Icon from './Icons';

export default function ThemeToggle() {
  const [dark, setDark] = useState(() => document.documentElement.classList.contains('dark'));

  useEffect(() => {
    const root = document.documentElement;
    root.classList.add('theme-transitioning');
    root.classList.toggle('dark', dark);
    try { localStorage.setItem('theme', dark ? 'dark' : 'light'); } catch (e) {}
    const t = setTimeout(() => root.classList.remove('theme-transitioning'), 450);
    return () => clearTimeout(t);
  }, [dark]);

  return (
    <button className="theme-toggle" onClick={() => setDark((d) => !d)} aria-label="Toggle light/dark theme">
      <Icon name={dark ? 'sun' : 'moon'} />
    </button>
  );
}
